import { render, staticRenderFns } from "./ServiceMultiPointDestination.vue?vue&type=template&id=5b9a9e0a&scoped=true&"
import script from "./ServiceMultiPointDestination.vue?vue&type=script&lang=js&"
export * from "./ServiceMultiPointDestination.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMultiPointDestination.vue?vue&type=style&index=0&id=5b9a9e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a9e0a",
  null
  
)

export default component.exports